import React from 'react';
import { Select } from 'antd';

import { COUNTRIES, CURRENCIES } from '../lib/countries';

/**
 * Country picker. `valueType="code"` stores the ISO code (counterparties,
 * VAT), `valueType="name"` stores the country name (client / company / staff
 * profiles, which the earlier free-text fields already hold as names).
 * Anything already stored that is not in the list is kept as an extra option
 * so old data still displays.
 */
export function CountrySelect({ valueType = 'name', value, onChange, ...rest }) {
  const options = COUNTRIES.map(([code, name]) => ({ value: valueType === 'code' ? code : name, label: valueType === 'code' ? `${name} (${code})` : name }));
  if (value && !options.some((o) => o.value === value)) options.unshift({ value, label: String(value) });
  return (
    <Select
      showSearch
      allowClear
      optionFilterProp="label"
      placeholder="Select a country"
      value={value || undefined}
      onChange={(v) => onChange && onChange(v === undefined ? null : v)}
      options={options}
      {...rest}
    />
  );
}

export function CurrencySelect({ value, onChange, ...rest }) {
  const options = CURRENCIES.map(([code, name]) => ({ value: code, label: `${code} - ${name}` }));
  if (value && !options.some((o) => o.value === value)) options.unshift({ value, label: String(value) });
  return (
    <Select
      showSearch
      optionFilterProp="label"
      placeholder="Currency"
      value={value || undefined}
      onChange={(v) => onChange && onChange(v)}
      options={options}
      {...rest}
    />
  );
}

export default CountrySelect;
